import { authStore } from '@/stores/auth'

const SUPER_ADMIN = 1
const BILLING_ADMIN = 28
const ACCESS_REQUESTS = '/access-requests'
const APP_PRICING = '/app-pricing'
const APP_USAGE = '/app-usage'
// The billing pages: roles 1 and 28 only, and the only pages a Billing Admin sees.
const BILLING_PAGES = [ACCESS_REQUESTS, APP_PRICING, APP_USAGE]

export default (to, from, next) => {
  const store = authStore()
  // exit if we are allowing anonymous
  if (to.matched.some((record) => record.meta.allowAnonymous)) {
    next()
    return
  }
  // exit if they are not authenticated
  if (!store.token) {
    // Remember a deep link (e.g. the reviewer email's /access-requests?id=) to return to
    // after login. The root is left out so its usual landing (Home or Launchpad) holds.
    if (to.fullPath !== '/') {
      store.setPassthrough(to.fullPath)
    }
    next('/login')
    return
  }
  // A user who is only a Billing Admin (role 28) works on ADAS Map Mobile billing (access
  // requests, app pricing, and app usage & credits) and nothing else (the API refuses them everything else), so
  // every other route sends them to the access requests; those pages are for roles 1 and
  // 28. Checked here rather than through isAllowed, which lets every role through.
  const roles = (store.profile && store.profile.roles) || []
  const isOnlyBillingAdmin = roles.length > 0 && roles.every((r) => r === BILLING_ADMIN)
  if (isOnlyBillingAdmin && !BILLING_PAGES.includes(to.path)) {
    next(ACCESS_REQUESTS)
    return
  }
  if (BILLING_PAGES.includes(to.path) && !roles.some((r) => [SUPER_ADMIN, BILLING_ADMIN].includes(r))) {
    next('/')
    return
  }
  // exit if they are not allowed by role
  if (!store.isAllowed(to.path)) {
    next('/')
    return
  }
  // allowed
  next()
}
